export namespace Constants {
    const NAME: string = "zrecursos";
    export const PX_PREFIJO_TITLE_ID: string = "px_title_";
    export const PX_PREFIJO_ID: string = "px_";
    export const REG_PREFIJO_ID: string = "_zreg_";
    export const ZFT_PREFIJO_ID: string = "_zft_";
}


// WEBPACK FOOTER //
// ./src/modules/zpantex/constants.ts